module.exports = __webpack_public_path__ + "img/jzaz.7bbdf5ba.png";